import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import personalImg from "../assets/service1.png"; 
import housingImg from "../assets/service1.png";
import vehicleImg from "../assets/service1.png";
import businessImg from "../assets/service1.png";
import goldImg from "../assets/service1.png";
import lapImg from "../assets/service1.png";
import icon1 from "../assets/icon1.png";
import icon2 from "../assets/icon2.png";
import icon3 from "../assets/icon3.png";
import icon4 from "../assets/icon4.png";
import icon5 from "../assets/icon5.png";
import icon6 from "../assets/icon6.png";

const loanTabs = [
  {
    key: "personal",
    title: "Personal Loan",
    iconImg: icon1,
    image: personalImg,
    heading: "Personal Loan",
    description: "Flexible loans designed to meet your personal needs with zero hassle.",
    subLoans: [
      { title: "Medical Loan", desc: "Cover unexpected medical expenses instantly." },
      { title: "Education Loan", desc: "Fund higher studies in India or abroad." },
      { title: "Marriage Loan", desc: "Make your special day memorable without financial stress." },
      { title: "Travel Loan", desc: "Finance your holidays & explore the world worry-free." },
    ],
  },
  {
    key: "housing",
    title: "Housing Loan",
    iconImg: icon2,
    image: housingImg,
    heading: "Housing Loan",
    description: "Affordable home loans with low-interest rates and quick approval.",
    subLoans: [
      { title: "Home Construction", desc: "Build your dream home easily." },
      { title: "Home Renovation", desc: "Upgrade or expand your home affordably." },
      { title: "Land Purchase", desc: "Buy land for your future home." },
    ],
  },
  {
    key: "vehicle",
    title: "Vehicle Loan",
    iconImg: icon3,
    image: vehicleImg,
    heading: "Vehicle Loan",
    description: "Own your dream car or bike with easy EMIs and fast disbursal.",
    subLoans: [
      { title: "Car Loan", desc: "Buy new or pre-owned cars easily." },
      { title: "Two-Wheeler Loan", desc: "Ride your favorite bike with simple financing." },
      { title: "Electric Vehicle Loan", desc: "Go green with affordable EV loans." },
    ],
  },
  {
    key: "business",
    title: "Business Loan",
    iconImg: icon4,
    image: businessImg,
    heading: "Business Loan",
    description: "Grow your business with flexible and fast business loans.",
    subLoans: [
      { title: "SME Loan", desc: "Boost your small or medium enterprise." },
      { title: "Startup Funding", desc: "Turn your idea into a successful business." },
      { title: "Working Capital Loan", desc: "Keep your business running smoothly." },
    ],
  },
  {
    key: "gold",
    title: "Gold Loan",
    iconImg: icon5,
    image: goldImg,
    heading: "Gold Loan",
    description: "Instant cash by pledging your gold safely.",
    subLoans: [
      { title: "Instant Gold Loan", desc: "Get money quickly using your gold ornaments." },
      { title: "Short-term Gold Loan", desc: "Repay easily within months." },
    ],
  },
  {
    key: "lap",
    title: "Loan Against Property",
    iconImg: icon6,
    image: lapImg,
    heading: "Loan Against Property",
    description: "Unlock the value of your property with low-interest secured loans.",
    subLoans: [
      { title: "Commercial Property Loan", desc: "Use your business property to raise funds." },
      { title: "Residential Property Loan", desc: "Leverage your home for personal needs." },
    ],
  },
];

export default function LoanTabsSection() {
  const [activeTab, setActiveTab] = useState("personal");
  const active = loanTabs.find((tab) => tab.key === activeTab);

  return (
    <div className="container-fluid py-5" style={{ overflow: "hidden" }}>
      <div className="row">
        <div className="col-10 mx-auto">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Types of Service We Offer</h2>
            <p className="text-muted">Explore now</p>
          </div>

      {/* Tabs */}
<div
  className="loan-tabs-container"
  style={{
    overflowX: "auto",
    whiteSpace: "nowrap",
  }}
>
  <ul
    className="nav nav-tabs mb-4 w-100 flex-nowrap flex-md-wrap justify-content-md-center"
    style={{
      border: "none",
      display: "flex",
      justifyContent: "center",
      gap: "0",
      minWidth: "600px", // ensures proper scroll spacing on small screens
    }}
  >
    {loanTabs.map((tab, index) => (
      <li
        className="nav-item flex-fill"
        key={tab.key}
        style={{
          textAlign: "center",
          flex: "0 0 auto",
          minWidth: "150px",
        }}
      >
        <button
          className={`nav-link d-flex flex-column align-items-center justify-content-center py-4 ${
            activeTab === tab.key ? "active" : ""
          }`}
          onClick={() => setActiveTab(tab.key)}
          style={{
            width: "100%",
            border: "1px solid #ddd",
            borderRadius:
              index === 0
                ? "12px 0 0 12px"
                : index === loanTabs.length - 1
                ? "0 12px 12px 0"
                : "0",
            backgroundColor: activeTab === tab.key ? "#1e50a2" : "#f8f9fa",
            color: activeTab === tab.key ? "#fff" : "#000",
            fontWeight: "600",
            fontSize: "16px",
            transition: "all 0.3s ease",
          }}
        >
          <img
            src={tab.iconImg}
            alt={tab.title}
            style={{
              width: "40px",
              height: "40px",
              objectFit: "contain",
              marginBottom: "8px",
              filter:
                activeTab === tab.key ? "brightness(0) invert(1)" : "none",
            }}
          />
          <span>{tab.title}</span>
        </button>
      </li>
    ))}
  </ul>
</div>

          <div className="row align-items-start">
            <div className="col-md-4 p-0">
              <div className="position-relative h-100">
                <img
                  src={active.image}
                  alt={active.title}
                  className="w-100 rounded-start"
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    minHeight: "320px",
                  }}
                />
                <div
                  className="position-absolute bottom-0 w-100 text-white p-3"
                  style={{
                    background: "rgba(0,0,0,0.5)",
                    borderBottomLeftRadius: "10px",
                  }}
                >
                  <h5 className="mb-0">{active.title} for Every Need</h5>
                </div>
              </div>
            </div>

            <div
              className="col-md-8 d-flex flex-column justify-content-start"
              style={{ padding: "0 40px" }}
            >
              <div>
                <h4 className="fw-bold mb-2">{active.heading}</h4>
                <p className="text-muted mb-4">{active.description}</p>
              </div>

              <div className="row g-3">
                {active.subLoans.map((item, idx) => (
                  <div key={idx} className="col-md-4">
                    <div className="p-3 border rounded-3 h-100">
                      <h6 className="fw-bold">{item.title}</h6>
                      <p className="text-muted small">{item.desc}</p>
                      <a href="#" className="text-primary fw-semibold"   onClick={() => {
    window.open("https://instantloan.shubhpaisa.com/", "_blank");
  }}>
                        Apply Now →
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
